import axiosClient from '../axiosClient';

const insertedCoinsService = {
  async fetchAll(filters = {}) {
    const response = await axiosClient.get('/inserted-coins', {
      params: filters,
    });
    return response.data;
  },

  async export(filters = {}) {
    const response = await axiosClient.get('/inserted-coins/export', {
      params: filters,
      responseType: 'blob',
    });
    return response;
  },
};

export default insertedCoinsService;
